export default "__VITE_ASSET__KWscGUNN__"